import React, { Component } from "react";
import Link from "gatsby-link";
import Gradhead from "../molecules/Gradhead";
import Floodbtn from "../molecules/Floodbtn";

const Cases = () => (
  <section>
    <div className="container">
      <div className="u-center u-clearfix">
        <Gradhead>Case studies</Gradhead>
      </div>
      <Floodbtn to="/cases/">
        <Link to="/cases/">See more</Link>
      </Floodbtn>
      <div className="cases--wrap">
        <div className="case">
          <div className="case--title">From prototype to success</div>
          <div className="case--subtitle">Dietopro</div>
          <div className="case--description">
            We planned and crafted this project from a prototype to test the
            market to a successful and growing business in the field of
            nutrition B2B.
          </div>
          <div className="case--link a--underline a--underline__pink">
            <Link to="/case-dietopro/">View case</Link>
          </div>
        </div>
        <div className="case">
          <div className="case--title">Tailored training and consulting</div>
          <div className="case--subtitle">PcComponentes</div>
          <div className="case--description">
            We provided this gifted team with technical guidance when they faced
            the challenge of modernizing the technical side of a business that,
            with yearly sales of 270M€ via internet, needs technical excellence.
          </div>
          <div className="case--link a--underline a--underline__pink">
            <Link to="/case-pccomponentes/">View case</Link>
          </div>
        </div>
        <div className="case">
          <div className="case--title">
            Migration of a successful legacy project
          </div>
          <div className="case--subtitle">Club Villamar</div>
          <div className="case--description">
            Migration of the platform to modern technologies and practices using
            React, Symfony and ElasticSearch for this monster of the luxury
            villa rental market in Spain. Development and consulting aligned
            with their business needs.
          </div>
          <div className="case--link a--underline a--underline__pink">
            <Link to="/case-villamar/">View case</Link>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Cases;



// WEBPACK FOOTER //
// ./src/organisms/Cases.js